export default {
  fi: {
    ReminderCreateScene: {
      addReminder: 'Lisää muistutus',
    },
  },
};
